import React from 'react';

export const BoostIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M7.08333 9.41683L5.08333 7.41683M7.08333 9.41683C8.01456 9.06266 8.90792 8.61598 9.75 8.0835M7.08333 9.41683V12.7502C7.08333 12.7502 9.10333 12.3835 9.75 11.4168C10.47 10.3368 9.75 8.0835 9.75 8.0835M5.08333 7.41683C5.4381 6.49645 5.8848 5.61421 6.41667 4.7835C7.19345 3.54149 8.27508 2.51886 9.55867 1.81289C10.8423 1.10692 12.2851 0.741079 13.75 0.750165C13.75 2.5635 13.23 5.75017 9.75 8.0835M5.08333 7.41683L1.75 7.41684C1.75 7.41684 2.11667 5.39684 3.08333 4.75018C4.16333 4.03018 6.41667 4.75018 6.41667 4.75018M2.08333 10.4169C1.08333 11.2569 0.75 13.7502 0.75 13.7502C0.75 13.7502 3.24333 13.4169 4.08333 12.4169C4.55667 11.8569 4.55 10.9969 4.02333 10.4769C3.7642 10.2296 3.42286 10.0866 3.06482 10.0756C2.70677 10.0645 2.35725 10.186 2.08333 10.4169Z"
      stroke="#8797AB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.08333 9.41683L5.08333 7.41683M7.08333 9.41683C8.01456 9.06266 8.90792 8.61598 9.75 8.0835M7.08333 9.41683V12.7502C7.08333 12.7502 9.10333 12.3835 9.75 11.4168C10.47 10.3368 9.75 8.0835 9.75 8.0835M5.08333 7.41683C5.4381 6.49645 5.8848 5.61421 6.41667 4.7835C7.19345 3.54149 8.27508 2.51886 9.55867 1.81289C10.8423 1.10692 12.2851 0.741079 13.75 0.750165C13.75 2.5635 13.23 5.75017 9.75 8.0835M5.08333 7.41683L1.75 7.41684C1.75 7.41684 2.11667 5.39684 3.08333 4.75018C4.16333 4.03018 6.41667 4.75018 6.41667 4.75018M2.08333 10.4169C1.08333 11.2569 0.75 13.7502 0.75 13.7502C0.75 13.7502 3.24333 13.4169 4.08333 12.4169C4.55667 11.8569 4.55 10.9969 4.02333 10.4769C3.7642 10.2296 3.42286 10.0866 3.06482 10.0756C2.70677 10.0645 2.35725 10.186 2.08333 10.4169Z"
      stroke="url(#paint0_linear_55729_15051)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_55729_15051"
        x1="0.277273"
        y1="13.7502"
        x2="14.4701"
        y2="13.6329"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4900FF" />
        <stop offset="0.462476" stopColor="#D500FF" />
        <stop offset="1" stopColor="#FF9257" />
      </linearGradient>
    </defs>
  </svg>
);
